import styled from 'styled-components/macro'
import Drawer from '@material-ui/core/Drawer'

export const SidebarWrapperBox = styled(Drawer)`
    @media only screen and (min-width: 960px) {
        display: none !important;
    }
`
